import OverlayTips from "../OverlayTips";

function LicensesPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

LicensesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($('#serviceAgreementRef'), {
            messageKey: "licensing.tips.service_agreement",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -30,
            offsetY: 10
        });

        this.add($('.licensePaneBorder'), {
            messageKey: "licensing.tips.active_license",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 0,
            offsetY: 0,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                anchor: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 100,
                offsetY: 10
            }
        });
    }
});

export default LicensesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/LicensesPageOverlayTipsManager.js